<div class="maintenance-page">
    <p class="picto">☕️</p>
    <h1 class="title">Nous revenons bientôt...</h1>
    <div class="main">
    Notre plateforme de billetterie est actuellement en maintenance pour améliorer nos services.
    Nous faisons le nécessaire pour rétablir l’accès rapidement. <br>
    Merci de votre compréhension.
    <span>L’équipe <a href="https://www.oandb.fr" target="blank">OandB</a>.</span>
    </div>
</div>